import cloneDeep from 'lodash/cloneDeep';

function logError(logger, error) {
  if (error.response) {
    logger.error(
      `Request was made and server responded with an error: ${JSON.stringify(error.response.data)} ${
        error.response.status
      } ${JSON.stringify(error.response.headers)}`,
    );
  } else {
    logger.error(`Request was made but no response was received: ${error.message}`);
  }

  const errorConfiguration = cloneDeep(error.config);
  delete errorConfiguration.data;
  logger.error(`Request configuration: ${JSON.stringify(errorConfiguration)}`);
}

export default class HttpErrorLogger {
  constructor(logger) {
    this.logger = logger;
  }

  handleError(error) {
    if (error) {
      logError(this.logger, error);
    }
  }
}
